import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/contacto-test")({
  component: ContactoTest,
});

function ContactoTest() {
  return (
    <div style={{ padding: 24, fontFamily: "Arial, sans-serif", background: "#fff", color: "#111" }}>
      <h1>Prueba de Contacto</h1>
      <form action="https://formspree.io/f/xykvlbwr" method="POST">
        <div style={{ marginBottom: 12 }}>
          <label htmlFor="ct-nombre">Nombre</label><br />
          <input id="ct-nombre" type="text" name="nombre" style={{ padding: 8, border: "1px solid #ccc", width: 280 }} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label htmlFor="ct-email">Email</label><br />
          <input id="ct-email" type="email" name="email" style={{ padding: 8, border: "1px solid #ccc", width: 280 }} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label htmlFor="ct-mensaje">Mensaje</label><br />
          <textarea id="ct-mensaje" name="mensaje" rows={4} style={{ padding: 8, border: "1px solid #ccc", width: 280 }} />
        </div>
        <button type="submit" style={{ padding: "8px 16px" }}>Enviar</button>
      </form>
    </div>
  );
}